import { useCallback, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { QueryKeys } from '@/modules/core/hooks';

import { UnappliedFundsTab } from '../UnappliedFunds.types';

const getTabFromSearch = (search: string) =>
  new URLSearchParams(search).get(QueryKeys.TAB) === UnappliedFundsTab.FUNDS_HISTORY
    ? UnappliedFundsTab.FUNDS_HISTORY
    : UnappliedFundsTab.UNPAID_INVOICES;

export const useUnappliedFundsTab = () => {
  const history = useHistory();
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState(() => getTabFromSearch(location.search));

  const changeTab = useCallback(
    (tab: UnappliedFundsTab) => {
      const params = new URLSearchParams(history.location.search);
      params.set(QueryKeys.TAB, tab);
      setCurrentTab(tab);
      history.replace({ pathname: history.location.pathname, search: `?${params.toString()}` });
    },
    [history]
  );

  return { currentTab, changeTab };
};
